module.exports = __webpack_public_path__ + "static/media/sfuidisplay-ultralight-webfont.47046f27.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/sfuidisplay-ultralight-webfont.woff
// module id = 266
// module chunks = 0